<div [formGroup]="formGroup" class="pure-g">
  <!-- Mode -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-select
      ngDefaultControl
      label="Mode"
      formControlName="repairMode"
      [disabled]="isEditMode"
      [attr.invalid]="isControlInErrorState(formGroup.controls['repairMode'])"
      fit="small"
      placeholder="Select a mode"
      (optionselected)="onModeChange($event)"
      required>
      @for (mode of repairModeList; track mode.code) {
        <mc-option [value]="mode.code">{{ mode.code }} - {{ mode.description }}</mc-option>
      }
      @if (formGroup.get('repairMode')?.hasError('required')) {
        <span slot="errormessage">Mode is required</span>
      }
    </mc-select>
  </div>

  <!-- Repair Code -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Repair Code" formControlName="repairCode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-typeahead
        ngDefaultControl
        label="Repair Code"
        formControlName="repairCode"
        [data]="repairCodeTypeaheadData"
        highlight="true"
        showlistonfocus="true"
        maxoptions="20"
        optionsheight="400px"
        placeholder="Type to search"
        [attr.invalid]="isControlInErrorState(formGroup.controls['repairCode'])"
        fit="small"
        required>
        @if (formGroup.get('repairCode')?.hasError('required')) {
          <span slot="errormessage">Repair Code is required</span>
        }
      </mc-typeahead>
    }
  </div>

  <!-- Part Number -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    @if (isEditMode) {
      <mc-input ngDefaultControl label="Part Number" formControlName="partCode" [disabled]="true" fit="small" required> </mc-input>
    } @else {
      <mc-typeahead
        ngDefaultControl
        label="Part Number"
        formControlName="partCode"
        [data]="partCodeTypeaheadData"
        highlight="true"
        showlistonfocus="true"
        maxoptions="20"
        optionsheight="400px"
        placeholder="Type to search"
        [attr.invalid]="isControlInErrorState(formGroup.controls['partCode'])"
        fit="small"
        required>
        @if (formGroup.get('partCode')?.hasError('required')) {
          <span slot="errormessage">Part Number is required</span>
        }
      </mc-typeahead>
    }
  </div>

  <!-- Max Part Quantity -->
  <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
    <mc-input
      ngDefaultControl
      label="Max Part Quantity"
      formControlName="maxQuantity"
      [attr.invalid]="isControlInErrorState(formGroup.controls['maxQuantity'])"
      fit="small"
      type="number"
      required>
      @if (formGroup.get('maxQuantity')?.hasError('required')) {
        <span slot="errormessage">Max Part Quantity is required</span>
      }
    </mc-input>
  </div>
</div>
